<div class="astrea-promotions">

    <div class="d-flex j-c-center mb-4 w-100">
        <div class="title t-center mb-3">
            <h2 class="mb-3">
                Combinamos Astrea Virtual con Inteligencia Artificial para proporcionar contenido de calidad a los profesionales
            </h2>
            <p>DE LA MANO DE LOS AUTORES MAS PRESTIGIOSOS DEL PAIS</p>
        </div>
    </div>

    <div class="promotions-grid">
        <div class="d-flex flex-column j-c-between a-i-center gap-15 mb-3">
            <img class="img-book img-responsive" src="/assets/images/home/home-book-1.png" alt="Libro del mes" />
            <h3>DOCTRINAS</h3>
            <a routerLink="/doctrine" class="btn btn-green" title="Novedades" mat-button>
                Ver doctrinas
            </a>
        </div>
        <div class="d-flex flex-column j-c-between a-i-center gap-15 mb-3">
            <img class="img-book img-responsive" src="/assets/images/home/home-book-2.png" alt="Colecciones" />
            <h3>COLECCIONES</h3>
            <a routerLink="/collections" class="btn btn-green" title="Novedades" mat-button>
                Ver colecciones
            </a>
        </div>
        <div class="d-flex flex-column j-c-between a-i-center gap-15 mb-3">
            <img class="img-responsive" src="/assets/images/astrea-brand/av-logo-green.png" alt="Astrea Virtual" />
            <div class="av-info">
                <p>Biblioteca jurídica online donde encontrará la versión digital de todos los libros de la Editorial Astrea, desde su inicio en 1968.</p>
                <br>
                <p>Además incluye artículos de doctrina inéditos y de revistas publicadas, en total más de 3500 obras asistidas por IA.</p>
            </div>
            <a routerLink="/astreavirtual" class="btn btn-green" title="Novedades" mat-button>
                Saber más
            </a>
        </div>
    </div>

</div>
